import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'moderator-rules',
            component: function () {
                return import(/* webpackChunkName: "rules" */ '../views/moderator/Rules.vue')
            },
        },
        {
            path: '/sid:id/sub:subid/',
            name: 'moderator-rules-category-sub',
            component: function () {
                return import(/* webpackChunkName: "rules-category" */ '../views/moderator/Rules.vue')
            },
        },
        {
            path: '/sid:id/sub:subid/rule:ruleid/',
            name: 'moderator-rules-detail',
            component: function () {
                return import(/* webpackChunkName: "rules-category" */ '../views/moderator/Rules.vue')
            },
        },
        {
            path: '/sid:id/',
            name: 'moderator-rules-category',
            component: function () {
                return import(/* webpackChunkName: "rules-category" */ '../views/moderator/Rules.vue')
            },
        },
        {
            path: '/settings:id/',
            name: 'rules-category-settings',
            component: function () {
                return import(/* webpackChunkName: "rules-category" */ '../views/moderator/SectionDetail.vue')
            },
        },
        {
            path: '/staff/',
            name: 'moderator-staff',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/Staff.vue')
            },
        },

        {
            path: '/contacts/',
            name: 'moderator-contacts',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/Contacts.vue')
            },
        },
        {
            path: '/screencasts/',
            name: 'screencasts',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../components/moderator/Screencasts.vue')
            },
        },
        {
            path: '/staff-doc/:id/:number/',
            name: 'moderator-staff-detail',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/StaffDetail.vue')
            },
        },
        {
            path: '/staff/contract/',
            name: 'moderator-contract',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/Contract.vue')
            },
        },
        {
            path: '/staff/contract/:sid/',
            name: 'moderator-contract',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/Contract.vue')
            },
        },
        {
            path: '/staff/contract/:sid/:id/',
            name: 'moderator-contract-detail',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff-detail" */ '../views/moderator/ContractDetail.vue')
            },
        },
        {
            path: '/staff/:sid/',
            name: 'moderator-staff',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/Staff.vue')
            },
        },
        {
            path: '/user-contact/:uid/',
            name: 'user-contract',
            component: function () {
                return import(/* webpackChunkName: "user-contract" */ '../views/moderator/UserContract.vue')
            },
        },
        {
            path: '/removed/',
            name: 'rules-removed',
            //props: route => ({ subid: 'removed'}),
            component: function () {
                return import(/* webpackChunkName: "rules" */ '../views/moderator/Rules.vue')
            },
        },
		{
            path: '/users-scheme/',
            name: 'users-scheme',
            component: function () {
                return import(/* webpackChunkName: "moderator-staff" */ '../views/moderator/UsersScheme.vue')
            },
        },
        {
            path: '*',
            name: 'page404',
            component: () => import(/* webpackChunkName: "404" */ '../views/moderator/Rules.vue'),
        }

    ],
    scrollBehavior (to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
})
